import { createPortal } from 'react-dom';
import { Loading } from '.'

export const LoadingModal = () => {

    return createPortal(
        <div className={'bg-opacity bg-general-blue'}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 20000
            }}
        >
            <Loading big white />
        </div>,
        document.body
    );
}
